import { render, staticRenderFns } from "./MoreOpsForTable.vue?vue&type=template&id=14c3b58e&"
import script from "./MoreOpsForTable.vue?vue&type=script&lang=ts&"
export * from "./MoreOpsForTable.vue?vue&type=script&lang=ts&"
import style0 from "./MoreOpsForTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports